import { TableCell, TableHead, TableRow, TableSortLabel } from 'material-ui/Table';
import Tooltip from 'material-ui/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';

class InvoicesTableHeader extends React.Component {

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property, this.state.columnData);
    };

    constructor(props) {
        super(props);

        const columnData = this.getColumnData();

        this.state = {
            columnData
        };
    }

    getColumnData = () => {
        const { t, showActions } = this.props;
        let columnData = [
            { id: 'Localizador', paddingLeft: '10px', numeric: false, sortType: 'String', disablePadding: false, label: t('INVOICES.INVOICE'), show: true },
            { id: 'Expediente', numeric: false, sortType: 'String', disablePadding: false, label: t('INVOICES.OLYMPIA_LOCATOR'), show: true },
            { id: 'FechaAlta', numeric: false, sortType: 'Date', disablePadding: false, label: t('INVOICES.INVOICE_DATE'), show: true },
            { id: 'Importe', numeric: false, sortType: 'Number', disablePadding: false, label: t('INVOICES.AMOUNT'), show: true },
            { id: 'Actions', numeric: false, sortType: 'NoSort', disablePadding: false, label: t('INVOICES.ACTIONS'), show: showActions },
            { id: 'Estado', numeric: false, sortType: 'String', disablePadding: false, label: t('INVOICES.STATE'), width: '32px', show: true },
        ];
        return columnData.filter(column => column.show);
    }

    render() {
        const { order, orderBy, t } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {this.state.columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                width={column.width}
                                style={{ width: column.width, backgroundColor: 'lightgrey', paddingLeft: column.paddingLeft }}
                                padding={'none'}
                                sortDirection={orderBy === column.id ? order : false}>
                                {
                                    column.sortType !== 'NoSort' ?
                                        <Tooltip
                                            title={column.sortType !== 'NoSort' ? t('INVOICES.SORT') : ''}
                                            placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                            enterDelay={300}>
                                            <TableSortLabel
                                                active={orderBy === column.id}
                                                direction={order}
                                                onClick={column.sortType !== 'NoSort' ? this.createSortHandler(column.id) : null}>
                                                {column.label}
                                            </TableSortLabel>
                                        </Tooltip>
                                        :
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={order}
                                            onClick={column.sortType !== 'NoSort' ? this.createSortHandler(column.id) : null}>
                                            {column.label}
                                        </TableSortLabel>
                                }
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

InvoicesTableHeader.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

export default translate('translations')(InvoicesTableHeader);


// WEBPACK FOOTER //
// ./src/components/Invoices/Table/InvoicesTableHeader.js